document.addEventListener("DOMContentLoaded", () => {
  const petalUrl = "https://cdn.shopify.com/s/files/1/0758/9704/5223/files/star.png?v=1777525759";

  const motionTypes = ["rotate-only", "flip-x", "flip-y", "flip-both"];

  let isRunning = true;

  function createPetal() {
    if (!isRunning) return;

    const wrap = document.createElement("div");
    wrap.className = "cherry-petal-wrap";

    const petal = document.createElement("img");
    petal.src = petalUrl;
    petal.className = "cherry-petal";

    const motion = motionTypes[Math.floor(Math.random() * motionTypes.length)];
    petal.classList.add(motion);

    const size = 16 + Math.random() * 18;
    const startLeft = Math.random() * 100;
    const duration = 9 + Math.random() * 7;
    const opacity = 0.45 + Math.random() * 0.45;
    const drift = -30 + Math.random() * 60;

    wrap.style.left = startLeft + "vw";
    wrap.style.animationDuration = duration + "s";
    wrap.style.setProperty("--drift-x", drift + "px");

    petal.style.width = size + "px";
    petal.style.opacity = opacity;
    petal.style.animationDuration = (2 + Math.random() * 3) + "s";

    wrap.appendChild(petal);
    document.body.appendChild(wrap);

    // remove petal after it finishes falling
    setTimeout(() => {
      wrap.style.opacity = "0";
      setTimeout(() => wrap.remove(), 2000);
    }, duration * 1000);
  }

  // spawn petals continuously
  const interval = setInterval(createPetal, 400);

  // ⏱ STOP creating new petals after 20 seconds
  setTimeout(() => {
    isRunning = false;
    clearInterval(interval);
  }, 10000);
});